import { cva } from "class-variance-authority";

export { default as BuildingToggleItem } from "./BuildingToggleItem";
export { default as BuildingToggleList } from "./BuildingToggleList";

export const variants = cva([], {
    variants: {
        size: {
            "notification-settings": ["h-13 md:h-11"],
        },
    },
});
